var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPoliticaDePrivacidade(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF7F41",
    d: "M451,472c0,22-18,40-40,40H101c-22,0-40-18-40-40V40c0-22,18-40,40-40h310c22,0,40,18,40,40V472z  M410.929,472c0.024-0.021,0.051-0.047,0.071-0.072V40.072c-0.021-0.025-0.047-0.052-0.071-0.072H101.071 c-0.024,0.021-0.051,0.047-0.071,0.072v431.855c0.021,0.025,0.047,0.052,0.071,0.072H410.929z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 96,
    fill: "#3CDBC0",
    width: 240,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 156,
    fill: "#3CDBC0",
    width: 240,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 216,
    fill: "#3CDBC0",
    width: 240,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 276,
    fill: "#3CDBC0",
    width: 85.573,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 336,
    fill: "#3CDBC0",
    width: 85.552,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 396,
    fill: "#3CDBC0",
    width: 85.552,
    height: 20
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7F41",
    d: "M261.573,323.11c0,40.292,22.696,75.283,56.001,92.89c33.304-17.607,55.999-52.599,55.999-92.89v-34.668 h-6.376c-17.949,0-34.846-4.502-49.623-12.442c-14.628,7.734-31.305,12.112-49.001,12.112h-7V323.11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoliticaDePrivacidade);
export default __webpack_public_path__ + "static/media/icon_politica_de_privacidade.0134af4062c6221dc66e7e6475558aac.svg";
export { ForwardRef as ReactComponent };